import * as React from 'react';
import * as request from 'superagent';
import  { withStyles } from '@mui/styles';
import { WithStyles, StyleRules, ClassNameMap } from '@mui/material/styles/withStyles';
import {Theme} from '@mui/material/styles';
import URLManager from '~common/lib/url-manager';
import Renderers from '~common/lib/renderers';
import Dropzone from '~common/components/versioned-document-dropzone';
import {Dialog, DialogContent, DialogTitle, LinearProgress, Grid} from '@mui/material';
import {eachLimit} from "async";
import HighlightOff from '@mui/icons-material/HighlightOff';
import RadioButtonChecked from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import Error from '@mui/icons-material/Error';
import { v4 as uuidv4 } from 'uuid';

var UPLOAD_CONCURRENCY = 1;
var MAX_SIZE = 20000000;
var MAX_PAGE_COUNT = 50;

const styles = (theme: Theme): StyleRules => ({
  container: {
    // paddingRight: 2,
    paddingBottom: 10
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
    dragStyle: any;
    status: 'ready' | 'uploading';
    uploadingFiles: Array<any>;
    error?: any;
};

class LovesDocumentAssemblyWebImport extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
        status: "ready",
        uploadingFiles: [],
        dragStyle: {
            background: "rgba(250,250,250,0.5)",
            textAlign: "center",
            border: "dashed 1px #aaa",
            color: "rgba(0,0,0,0.6)",
            fontSize: "1.2em",
            cursor: "pointer",
            padding: 40
          },
    };
  }

  componentDidMount() {
   

  }

  static register = () => {
    console.log("Registering LovesDocumentAssemblyWebImport")
    if(!Renderers.find("LovesDocumentAssemblyWebImport")){
      console.log("Registering LovesDocumentAssemblyWebImport")
      Renderers.register("LovesDocumentAssemblyWebImport", withStyles(styles)(LovesDocumentAssemblyWebImport))
    }
  }

  onDrop = (acceptedFiles: Array<any>, rejectedFiles: Array<any>) => {
    var self = this

    console.log("onDrop acceptedFiles", acceptedFiles)
    console.log("onDrop rejectedFiles", rejectedFiles)

    var {dragStyle} = this.state

    if (rejectedFiles && rejectedFiles.length > 0) {

      rejectedFiles.forEach((rf)=>{

        rf.name = rf.file.name
        rf.error = " was rejected"
        rf.status = "failed"

        if (rf.errors.find((e:any)=>{return e.code == "file-too-large"})) {
          rf.status = "maxSizeExceeded"
          rf.error += " - max size exceeded"
        }

        if (rf.errors.find((e:any)=>{return e.code == "file-invalid-type"})) {
          rf.status = "invalidFileType"
          rf.error += " - invalid file type"
        }

      })
      
      self.setState({
        status: "complete",
        uploadingFiles: rejectedFiles,
        dragState: null, 
      })
    
    } else {

      // accepted file count limitation?

      this.setState({
        dragStyle: dragStyle,
        status: "uploading",
        uploadingFiles: acceptedFiles
      }, ()=>{

        console.log("acceptedFiles length", acceptedFiles.length)

        var hasManualAssembly = false

        eachLimit(
            acceptedFiles,
            UPLOAD_CONCURRENCY,
            function(f: any, cb) {

                var {uploadingFiles} = self.state

                f.status = "uploading";
                f.startDt = new Date();

                setTimeout(function() {
                    if (f.status == "uploading") {
                      f.bigFileWarning = true;
                    }
                    self.setState({});
                  }, 15000);

                var forcePageCount = false
                if (f.type == "image/png" || f.type == "application/pdf" || f.type == "image/jpeg" || f.type == "image/tiff") {
                  forcePageCount = true
                }

                request.post(`/api/attachment-storage?opts={"forcePageCount":${forcePageCount}, "skipHydration": true}`).set('Accept', 'application/json').attach(f.name, f)
                    .then((response)=>{
                        console.log("responsex", response)
                        
                        if (response.body.pageCount > MAX_PAGE_COUNT) {
                          f.error = " was rejected - exceeds max page count"
                          f.status = "maxPageCountExceeded";
                          self.setState({status: "complete", dragState: null, });
                          cb();
                          return
                        }

                        var docEngineResponse = response.body

                        docEngineResponse.hydrationStatus = "Dehydrated"
                        docEngineResponse.fileName = f.name
                        docEngineResponse.mimeType = f.type
                        docEngineResponse.webhookID = uuidv4()

                        request.post("/api/capture/document-assembly/submit").set('accept', 'application/json').send(docEngineResponse)
                            .then((response)=>{

                                f.status = response.body.status

                                if (f.status == "manual assembly") {
                                  hasManualAssembly = true
                                }

                                self.setState({
                                    dragState: undefined,
                                    status: "uploading"
                                });
                                cb()
                            }).catch(()=>{
                                // console.log("err", err)
                                f.error = "Error uploading " + f.name;
                                f.status = "failed";
                                self.setState({});
                                cb()
                            })
                    }).catch((err)=>{
                        console.log("err", err)
                        f.error = "Error uploading " + f.name;
                        f.status = "failed";
                        self.setState({});
                        cb()
                })
            },
            // eachLimit cb
            function(err) {
                
                self.setState({ 
                  status: "ready"
                }, ()=>{

                  var qs = URLManager.getQueryString(window.location.href)

                  console.log("qs", qs)
                  var limit = 10
                  if (qs && qs.limit) {
                    limit = qs.limit
                  }

                  if (hasManualAssembly) {
                    self.props.executeQuery({source: "DAT Web", sortBy: "createdAt", sortDirection: "desc", limit: limit, skip: 0})
                  }
                });
              }
          );
      })
    }
  }

  handleClose = (evt: any, reason: string) => {
    if (reason != "backdropClick") {
        this.setState({
            status: "ready"
        })
    }
}

clearUploads = () => {
    this.setState({ status: "ready", uploadingFiles: [] });
}


  render() {
    const {classes}: {classes: ClassNameMap} = this.props;

    const { status, dragState, dragStyle, uploadingFiles } = this.state

    var filePrompt: any;
    filePrompt = "Click here or drop a file here to upload.";
    if (dragState === "rejected") {
        filePrompt = "That file is no bueno";
    }

    var dropzone = (
      // <div>DROPZONE</div>
        <Dropzone
            maxSize={MAX_SIZE}
            onDrop={this.onDrop}
            multiple={true}
            accept={
              {
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
                'text/plain':[],
                'text/csv': [],
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
                'image/jpeg': [],
                'application/pdf': [],
                'image/png': [], 
                'image/tiff': [], 
              }
            }>
            <div style={dragStyle}>
                {filePrompt}
            </div>
		    </Dropzone>
    )

    var uploadingDialog
    if (status == "uploading") {
        uploadingDialog = (
            <Dialog
                onClose={this.handleClose}
                disableEscapeKeyDown={true}
                open={true}
            >	
                <DialogTitle>
                    <LinearProgress/>
                </DialogTitle>
                <DialogContent>
                
                    Please do not navigate away from this page until processing is complete.  Navigation will result in loss of data.
            
                </DialogContent>
            </Dialog>
            )
    }

    if (uploadingFiles && uploadingFiles.length > 0) {
        filePrompt = uploadingFiles.map((f: any, idx)=>{

            console.log("rendering f", f)

            var icon = <RadioButtonUnchecked/>
            var description ;

            switch (f.status) {
            case "uploading":
                if (f.bigFileWarning) {
                    icon = <RadioButtonUnchecked style={{ color: "#aaaaaa", fontSize: "1.1em" }}/>
                    description = "Large files or files with many pages may take longer to process.";
                } else {
                    icon = <RadioButtonUnchecked style={{ color: "#aaaaaa", fontSize: "1.1em" }}/>
                    description = "Uploading...";
                }
                break;
            case "failed":
                icon = <Error style={{ color: "#dd0000", fontSize: "1.1em" }}/>
                description = f.error + " Please try again";
                break;
            case "invalidFileType":
            case "maxSizeExceeded":
            case "maxPageCountExceeded":
                icon = <Error style={{ color: "#dd0000", fontSize: "1.1em" }}/>
                description = f.error
                break;
            case "assembled":
                icon = <RadioButtonChecked style={{ color: "#00dd00", fontSize: "1.1em" }} />
                description = "Item did not require assembly and will route for initial review.";
                break;
            case "auto assembly":
              icon = <RadioButtonChecked style={{ color: "#00dd00", fontSize: "1.1em" }} />
              description = "Document is being automatically assembled. A new task will be created below once assembly is complete.";
              break;
            case "manual assembly":
                icon = <RadioButtonChecked style={{ color: "#00dd00", fontSize: "1.1em" }} />
                description = "Document requires manual assembly. ";
                break;
            default:
                icon = <RadioButtonUnchecked style={{ color: "#aaaaaa", fontSize: "1.1em" }}/>
                break;
            }

            var gridSize = 11
            if (idx==0) {
                gridSize = 12
            }
            return (
                <Grid container spacing={3} style={{textAlign: "left",  paddingLeft: 15,paddingRight: 15,paddingTop: 0,paddingBottom: 4}}>
                    <Grid item xs={gridSize} sm={gridSize} md={gridSize} lg={gridSize} xl={gridSize}>
                        <div style={{ width: 20, display: "inline-block" }}>{icon}</div>
                        <span style={{ marginLeft: 15, marginRight: 15, fontWeight: 600}}>
                        {f.name}
                        </span>
                        <span>{description}</span>
                        {idx == 0 && <HighlightOff
                            style={{float: 'right', zIndex: 99999, color: "#888", cursor: "pointer", fontSize: "1.2em"}}
                            onClick={this.clearUploads}
                        />}
                    </Grid>
                </Grid>
            );
        })

        dropzone = (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div style={{backgroundColor: "#fdfdfd", border: "dashed 1px #aaa", minHeight: 100, paddingTop: 4, paddingBottom: 4, marginLeft: 15, marginRight: 15}}>
                    {filePrompt}
                </div>
              </Grid>
            </Grid>
          );
    }

    return (
        <div className={classes.container}>
            {uploadingDialog}
            {dropzone}
        </div>
    );
  }
}

export default withStyles(styles)(LovesDocumentAssemblyWebImport);
